export default "/images/598ad71ca7d5417f68cae1d6208a1d96.png";